import { createContext } from "react";

const ProyectoContext = createContext();

export default ProyectoContext;